import React, { useState, useEffect, useContext } from "react";
import PublicationMetrics from "./PublicationMetrics";
import PublicationToolbar from "./PublicationToolbar";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
// import TableDetails from "../DataTable/TableDetails";
import TableDetails from "../table/TableDetails";
import "./PublicationDetails.scss";
import { config } from "@fortawesome/fontawesome-svg-core";
import { AppContext } from "../../context/AppContext";
import { KEY_NAME } from "../../utils/KeyName";
import AboutChartToggle from "../AboutChartToggle/AboutChartToggle";
// import { useState } from "react";

const headers = [
  { label: "DOI", accessor: "doi", sortable: true },
  { label: "ARTICLE TITLE", accessor: "title", sortable: true },
  { label: "AUTHOR(S)", accessor: "authors", sortable: true },
  { label: "JOURNAL NAME", accessor: "journal", sortable: true },
];

const TABLE_CONFIG = [
  {
    display: "DOI",
    field: "doi",
    sortKey: "doi",
    dataType: "url",
    sortable: true,
    clickable: true,
    tableDisplay: true,
    children: null,
  },
  {
    display: "TITLE",
    field: "title",
    sortKey: "title",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: true,
    children: null,
  },
  {
    display: "AUTHORS",
    field: "authors",
    sortKey: null,
    dataType: "text",
    sortable: false,
    clickable: false,
    tableDisplay: true,
    children: null,
  },
  {
    display: "JOURNAL",
    field: "journalName",
    sortKey: "journalName",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: true,
    children: null,
  },
  {
    display: "LICENSE TYPE",
    field: "licenseType",
    sortKey: "licenseType",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "LICENSE URL",
    field: "licenseUrl",
    sortKey: "licenseUrl",
    dataType: "url",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "REUSE LICENSE START DATE",
    field: "licenseDate",
    sortKey: "licenseDate",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "FUNDERS",
    field: "funders",
    sortKey: "funders",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "DATA SET",
    field: "datasetsDli",
    sortKey: "datasetsDli",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "ONLINE PUBLICATION DATE",
    field: "onlinePublicationDate",
    sortKey: "onlinePublicationDate",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "PRINT PUBLICATION DATE",
    field: "printPublicationDate",
    sortKey: "printPublicationDate",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "LAST AUDITED ON",
    field: "lastAudit",
    sortKey: "lastAudit",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "OPEN ACCESS ON PUBLISHER SITE",
    field: "publiclyAccessibleDate",
    sortKey: "publiclyAccessibleDate",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "ADDED ON",
    field: "createdAtDate",
    sortKey: "createdAtDate",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
  {
    display: "UPDATED ON",
    field: "updatedAtDate",
    sortKey: "updatedAtDate",
    dataType: "text",
    sortable: true,
    clickable: false,
    tableDisplay: false,
    children: null,
  },
];

const PublicationDetails = ({
  tableData,
  setTableData,
  totalRecords,
  publisherCount,
  selectedPublisher,
  setSelectedPublisher,
  queryData,
  setQueryData,
  handleSort,
  onRowClick,
  loading,
  metricsLoading,
  onSearch,
  onChange,
}) => {
  const { get } = useCustomSearchParams();
  const { entityName } = useContext(AppContext);
  const [filteredTableConfig, setFilteredTableConfig] = useState(null);

  const handleShowHideFilter = (selectedField) => {
    setFilteredTableConfig(
      tableData.config.map((item) =>
        selectedField.includes(item.field)
          ? { ...item, tableDisplay: true }
          : { ...item, tableDisplay: false },
      ),
    );
  };

  // Restore a shared/reloaded URL's column selection once the table config
  // arrives. Only runs when no in-session selection exists yet, so it never
  // clobbers a choice the user just made via the dropdown.
  useEffect(() => {
    if (!tableData?.config || filteredTableConfig) return;
    const urlVisibleFields = get(SEARCH_PARAMS.VISIBLE_FIELDS);
    if (!urlVisibleFields) return;
    handleShowHideFilter(urlVisibleFields.split(","));
  }, [tableData?.config]);
  return (
    <div className="publication-details">
      <PublicationMetrics
        publisherCount={publisherCount}
        matricsKey={selectedPublisher}
        setSelectedPublisher={setSelectedPublisher}
        metricsLoading={metricsLoading}
      />

      <div className="mb-3">
        <AboutChartToggle notes="Click on the radio buttons to display results for the key performance indicator chosen" />
      </div>

      {/* {entityName !== KEY_NAME.FUNDER && (
        <div className="mb-3">
          <AboutChartToggle notes="The On Funder Portal results in the ribbon should return only results with DOIs that report On Funder Portal results." />
        </div>
      )} */}

      {tableData?.config && (
        <PublicationToolbar
          // agencyId={queryData?.agencyId?.replace("/", ",")}
          agencyId={queryData?.agencyId}
          memberId={queryData?.memberId}
          selectedFunderFromTable={queryData.clickedFunder}
          publisherCount={publisherCount}
          onSearch={onSearch}
          onChange={onChange}
          handleShowHideFilter={handleShowHideFilter}
          tableConfig={tableData?.config}
          selectedSearchValue={get(SEARCH_PARAMS.ENTITY_DETAILS_SEARCH)}
        />
      )}

      <hr />
      <TableDetails
        tableData={tableData?.data}
        headers={filteredTableConfig || tableData.config}
        totalRecords={totalRecords}
        paginationData={{ page: queryData.page, size: queryData.size }}
        setPaginationData={setQueryData}
        headerClassification={true}
        showPagination={true}
        start={0}
        handleSort={handleSort}
        sort={{
          field: queryData.sortKey,
          order: queryData.sortOrder,
        }}
        onRowClick={onRowClick}
        loading={loading}
        stickyTableHeader={true}
      />
    </div>
  );
};

export default PublicationDetails;
